import { Menu } from 'antd'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const StyledMenu = styled(Menu)`
  flex: auto;
  justify-content: ${props => (props.$end ? 'flex-end' : 'flex-start')};
`

StyledMenu.propTypes = {
  $end: PropTypes.bool,
}

StyledMenu.defaultProps = {
  $end: false,
}

export default StyledMenu
